import CDialog from '01_core/components/materials/CDialog';
import { CALLAPI_REJECT_REASON, withCallAPI } from '01_core/components/system/CallAPI';
import {
  HOME_DISPLAY_SETTING_INIT_GROUPHISAI,
  STATUS,
  SYSLOGIN_APPROVE,
  SYSLOGIN_LOGIN,
} from '01_core/constants/APIs';
import { LABEL } from '01_core/constants/labelConsts';
import { LOCAL_STORAGE_KEY, STRING_CONSTS } from '01_core/constants/stringConsts';
import { EN } from '01_core/locales/en';
import { JA } from '01_core/locales/ja';
import { INFOBAR_VARIANT, TYPES_INFO_BAR, coreInfoBarActions } from '01_core/reducers/coreInfoBarActions';
import { TYPES_LOCALE, coreLocaleActions } from '01_core/reducers/coreLocaleActions';
import { TYPES_LOGIN_INFO, coreLoginInfoActions } from '01_core/reducers/coreLoginInfoActions';
import { InteractionStatus } from '@azure/msal-browser';
import { withMsal } from '@azure/msal-react';
import DialogContent from '@mui/material/DialogContent';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PrivacyPolicy from './components/PrivacyPolicy';
import NotAgree from './components/NotAgree';
import SelfAuth from './components/SelfAuth';
import { CONTENTS, TYPES, loginActions } from './loginActions';
import authEnvUtil, { AUTH_ENV_KEY } from '01_core/logics/authEnvUtil';

/**
 * ログイン機能コンテナ
 */
class LoginContainer extends React.Component {
  componentDidMount = () => {
    this.props.initLocale();
    this.props.initLoginInfo();
    this.props.setLabel({ en: EN, ja: JA });
    
    if (this.isSelfAuth()) {
      this.props.setDispContent(CONTENTS.SELF_AUTH);
    } else {
      this.callAADLogin();
    }

  };

  componentDidUpdate(prevProps) {
    if ((prevProps.state.selfAuth.mailAddress !== this.props.state.selfAuth.mailAddress) ||
      ((prevProps.state.selfAuth.exec !== this.props.state.selfAuth.exec) && (this.props.state.selfAuth.exec === true))) {
      this.callSelfAuthLogin();
    }
    if (prevProps.msalContext.inProgress !== this.props.msalContext.inProgress) {
      this.callAADLogin();
    }
  }

  isSelfAuth() {
    const selfAuthFlg = authEnvUtil.getEnv(AUTH_ENV_KEY.SELF_AUTH_FLG);
    return selfAuthFlg === '1';
  }

  // Azure ADでのログイン
  callAADLogin() {
    // 独自認証の場合は処理しない
    if (this.isSelfAuth()) {
      return;
    }

    const isAuthenticated = this.props.msalContext.accounts.length > 0;
    const context = this.props.msalContext;

    if (context.inProgress === InteractionStatus.None) {
      if (isAuthenticated) {
        // OneNECのログイン処理
        const mailAddress = context.accounts[0].username;
        const idToken = context.accounts[0].idToken;
        this.systemLogin(mailAddress, idToken);
      } else {
        // Azure ADのログイン画面にリダイレクト
        context.instance.loginRedirect();
      }
    }
  }

  // 独自認証画面からのログイン
  callSelfAuthLogin() {
    // 独自認証以外の場合は処理しない
    if (!this.isSelfAuth()) {
      return;
    }

    const mailAddress = this.props.state.selfAuth.mailAddress;
    if (mailAddress) {
      this.props.setSelfAuth({mailAddress, exec: false});
      // OneNECのログイン処理
      this.systemLogin(mailAddress, null);
    }
  }

  loginSuccess = (loginResponse) => {
    const { setSessionId, systemLoginSuccess, history } = this.props;
    setSessionId(loginResponse.access_token);
    systemLoginSuccess();
    global.localStorage.removeItem(LOCAL_STORAGE_KEY.FILTER_BY_DATE);
    history.push(STRING_CONSTS.ROOT_PATH);
  };

  systemLogin = (mailAddress, idToken) => {
    const { callAPI, setPrivacyPolicy, handleOpenPopup, handleClosePopup, intl } = this.props;
    const url = SYSLOGIN_LOGIN;
    const data = {
      userId: 'dummy',
      pass: 'dummy',
      client_id: 'oauth_client',
      client_secret: 'secret',
      grant_type: 'password',
      mailAddress: mailAddress,
      idToken: idToken ?? STRING_CONSTS.EMPTY,
      isSelfAuth: idToken ? '0' : '1',
      isTest: authEnvUtil.getEnv(AUTH_ENV_KEY.TEST_FLG),
    };

    callAPI(url, data)
      .then((result) => {
        if (result.status === STATUS.SUCCESS) {
          this.awaitFirstLogin(result);
          if (result.approve !== '同意済み') {
            if (result.privacypolicy) {
              setPrivacyPolicy(result.privacypolicy);

              handleOpenPopup(
                intl.formatMessage({ id: LABEL.COMMON_SYSLOGIN_PRIVACY_POLICY }),
                <PrivacyPolicy onCancelClick={handleClosePopup} onOkClick={() => this.handleAgree(result)} />,
              );
            } else {
              this.showInfoBar(intl.formatMessage({ id: LABEL.COMMON_SYSLOGIN_SYSTEM_UNAVAILABLE }));
            }
          } else {
            this.loginSuccess(result);
          }
        } else {
          this.showInfoBar(result.message);
        }
      })
      .catch((e) => {
        if (e.reason !== CALLAPI_REJECT_REASON.CALLING) {
          this.showInfoBar(intl.formatMessage({ id: LABEL.CORE_SYSTEM_ERROR_MESSAGE }));
        }
      });
  };

  handleAgree = (loginResponse) => {
    const { callAPI, handleClosePopup, intl } = this.props;
    const url = SYSLOGIN_APPROVE;
    const data = {
      userId: loginResponse.loginUser.loginUserAuth.kaishaCd + loginResponse.loginUser.loginUserAuth.shainId,
    };

    handleClosePopup(false);

    callAPI(url, data, loginResponse.access_token)
      .then((result) => {
        if (result.status === STATUS.SUCCESS) {
          this.loginSuccess(loginResponse);
        } else {
          this.showInfoBar(intl.formatMessage({ id: LABEL.CORE_SYSTEM_ERROR_MESSAGE }));
        }
      })
      .catch((e) => {
        if (e.reason !== CALLAPI_REJECT_REASON.CALLING) {
          this.showInfoBar(intl.formatMessage({ id: LABEL.CORE_SYSTEM_ERROR_MESSAGE }));
        }
      });
  };

  awaitFirstLogin = async (loginResponse) => {
    if (loginResponse.firstLogin) {
      await this.firstLogin(loginResponse);
    }
  };

  firstLogin = (loginResponse) => {
    const { callAPI } = this.props;
    const token = loginResponse.access_token;
    return Promise.all([
      callAPI(HOME_DISPLAY_SETTING_INIT_GROUPHISAI, {}, token).catch((e) => {
        return e;
      }),
    ]);
  };

  showInfoBar = (message) => {
    this.props.openInfoBar(INFOBAR_VARIANT.ERROR, message);
  };

  render() {
    const { state, handleClosePopup, intl } = this.props;

    switch  (state.dispContent) {
      case CONTENTS.SELF_AUTH:
        return <SelfAuth />;

      case CONTENTS.NOT_AGREE:
        return <NotAgree />;

      default:
        return (
          state.popupContents &&
          <CDialog
            open={state.isOpenPopup}
            handleClose={handleClosePopup}
            title={intl.formatMessage({ id: LABEL.COMMON_SYSLOGIN_PRIVACY_POLICY })}
            fullWidth={false}
            maxWidth={false}
          >
            <DialogContent>{state.popupContents}</DialogContent>
          </CDialog>
        );
    }
  }
}

const mapStateToProps = (state) => ({
  state: state.commonLogin,
});

const mapDispatchToProps = (dispatch) => ({
  setLabel: (label) => dispatch(coreLocaleActions[TYPES_LOCALE.SET_LABEL](label)),
  initLocale: () => dispatch(coreLocaleActions[TYPES_LOCALE.INIT]()),
  initLoginInfo: () => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.INIT]()),
  handleOpenPopup: (title, contents) => dispatch(loginActions[TYPES.OPEN_POPUP](title, contents)),
  handleClosePopup: (isCancel) => dispatch(loginActions[TYPES.CLOSE_POPUP](isCancel)),
  systemLoginSuccess: () => dispatch(loginActions[TYPES.SYSTEM_LOGIN_SUCCESS]()),
  setSessionId: (sessionId) => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.SET_SESSION_ID](sessionId)),
  openInfoBar: (type, message) => dispatch(coreInfoBarActions[TYPES_INFO_BAR.OPEN](type, message)),
  setPrivacyPolicy: (contents) => dispatch(coreLocaleActions[TYPES_LOCALE.SET_PRIVACY_POLICY](contents)),
  setDispContent: (content) => dispatch(loginActions[TYPES.SET_DISP_CONTENT](content)),
  setSelfAuth: (selfAuth) => dispatch(loginActions[TYPES.SET_SELF_AUTH](selfAuth)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withMsal(withCallAPI(injectIntl(LoginContainer))));
